type ZoomableImageProps = {
    imageClassName: string;
    imageInGrayScale?: boolean;
    rotationDegrees: number;
    src: string;
    translate: { x: number; y: number };
    zoomLevel?: number;
};

export function ZoomableImage({
    imageClassName,
    imageInGrayScale,
    rotationDegrees,
    src,
    translate,
    zoomLevel = 1,
}: ZoomableImageProps) {
    return (
        <img
            alt="zoomable"
            className={imageClassName}
            draggable={false}
            src={src}
            style={{
                objectFit: 'contain',
                ...(imageInGrayScale && { filter: 'grayscale(100%)' }),
                transform: `
                    translateX(${translate.x}px)
                    translateY(${translate.y}px)
                    scale(${zoomLevel})
                    rotate(${rotationDegrees}deg)
                `,
            }}
        />
    );
}
